export default __webpack_public_path__ + "static/media/loadingMap2.78e735c5.gif";